/** What a group of holdings is there to do. */
export type Job = 'Grow' | 'Cushion' | 'Balance';

export type GroupKey = 'chips' | 'tech' | 'cushion' | 'energy' | 'health' | 'banks' | 'other';

export type Group = {
  label: string;
  job: Job;
  /** Tile fill, from the brand's part palette (dark to light). */
  bg: string;
  /** Text on the tile. */
  fg: string;
};

export const GROUPS: Record<GroupKey, Group> = {
  chips: { label: 'Chips & AI', job: 'Grow', bg: '#08150C', fg: '#FFFFFF' },
  tech: { label: 'Big tech', job: 'Grow', bg: '#2F4A36', fg: '#FFFFFF' },
  cushion: { label: 'Gold & cash', job: 'Cushion', bg: '#D9C9A8', fg: '#08150C' },
  energy: { label: 'Energy', job: 'Balance', bg: '#5E7A63', fg: '#FFFFFF' },
  health: { label: 'Healthcare', job: 'Balance', bg: '#93A792', fg: '#08150C' },
  banks: { label: 'Banks', job: 'Balance', bg: '#C2CDB9', fg: '#08150C' },
  other: { label: 'Other', job: 'Balance', bg: '#E8E1D3', fg: '#08150C' },
};

type Meta = { group: GroupKey; short: string };

const BY_TICKER: Record<string, Meta> = {
  AMD: { group: 'chips', short: 'AMD' },
  SMH: { group: 'chips', short: 'Chip fund' },
  NVDA: { group: 'chips', short: 'NVIDIA' },
  TSM: { group: 'chips', short: 'TSMC' },
  AVGO: { group: 'chips', short: 'Broadcom' },
  GOOGL: { group: 'tech', short: 'Google' },
  AAPL: { group: 'tech', short: 'Apple' },
  GLD: { group: 'cushion', short: 'Gold' },
  BIL: { group: 'cushion', short: 'T-bills' },
  XOM: { group: 'energy', short: 'Exxon' },
  LLY: { group: 'health', short: 'Eli Lilly' },
  JPM: { group: 'banks', short: 'JPMorgan' },
};

/** Logos shipped in public/logos. A holding without one falls back to its initial. */
const LOGOS = new Set(Object.keys(BY_TICKER));

export type HoldingMeta = Meta & { logo: string | null };

export function holdingMeta(ticker: string, companyName?: string | null): HoldingMeta {
  const meta = BY_TICKER[ticker] ?? { group: 'other' as GroupKey, short: companyName || ticker };
  return { ...meta, logo: LOGOS.has(ticker) ? `/logos/${ticker}.webp` : null };
}
